<template>
  <div class="one-task-container">
    <div class="status-container">
      <div class="status-icon"><img 
      :src="getTaskStatusIcon"
       :class="{'just-get-the':taskData.justGetThe || getCouponStatus==1}"
       alt=""
       @click="handleUse"
        /></div>
    </div>
    <div class="desc-line_content">
      <div class="desc-line">{{ taskData.descFirstLine }}</div>
      <div class="desc-line">{{ taskData.descSecondLine }}</div>
    </div>
    <div class="go-order" :class="{ 'go-order1': taskData.justGetThe || getCouponStatus == 2 }">
      <rich-button @click="handleUse">
        {{ getBtnText }}
      </rich-button>
    </div>
  </div>
</template>

<script>
import { getScheme } from '@/common/js/utils'
import {homepageTaskOrderButtonCk} from '../../trackEvent'
import NOCOMPLETEICON from '@/assets/images/oldCustomer/status1.png'
import NOREWORDICON from '@/assets/images/oldCustomer/status2.png'
import COMPLETEICON from '@/assets/images/oldCustomer/status3.png'
import TORECEIVE from '@/assets/images/oldCustomer/status4.gif'
import GETSUCCESS from '@/assets/images/oldCustomer/get_success.gif'

import NOCOMPLETEICON99 from '@/assets/images/oldCustomer/99_status1.png'
import NOREWORDICON99 from '@/assets/images/oldCustomer/99_status2.png'
import COMPLETEICON99 from '@/assets/images/oldCustomer/99_status3.png'
import TORECEIVE99 from '@/assets/images/oldCustomer/99_status4.gif'
import GETSUCCESS99 from '@/assets/images/oldCustomer/99_get_success.gif'

Object.freeze(NOCOMPLETEICON)
Object.freeze(NOREWORDICON)
Object.freeze(COMPLETEICON)
Object.freeze(NOCOMPLETEICON99)
Object.freeze(NOREWORDICON99)
Object.freeze(COMPLETEICON99)
Object.freeze(TORECEIVE)
Object.freeze(TORECEIVE99)
Object.freeze(GETSUCCESS)
Object.freeze(GETSUCCESS99)

export default {
  name: 'OneTaskStatus',
  props: {
    taskData: {
      default: () => {}
    },
    currentLadderNum: {
      default: 0
    },
    getTaskListDataLength: {
      default: 0
    },
    activityID: {
      default: ''
    }
  },

  computed: {
    country () {
      return this.$store.state.country
    },
    getTaskStatusIcon () {
      if (this.taskData.justGetThe) {
        // 刚刚领取任务
        if (this.country === 'BR') {
          return GETSUCCESS99
        } else {
          return GETSUCCESS
        }
      } else if (this.taskData.ladderNum == 0) { //eslint-disable-line

        if (this.country === 'BR') {
          return NOREWORDICON99
        } else {
          return NOREWORDICON
        }
      } else if (this.getCouponStatus === 3) {
        // 待完成
        if (this.country === 'BR') {
          return NOCOMPLETEICON99
        } else {
          return NOCOMPLETEICON
        }
      } else if (
        this.getCouponStatus === 1
      ) {
        // 待领取
        if (this.country === 'BR') {
          return TORECEIVE99
        } else {
          return TORECEIVE
        }
      } else if (
        this.getCouponStatus === 2
      ) {
        // 已领取
        if (this.country === 'BR') {
          return COMPLETEICON99
        } else {
          return COMPLETEICON
        }
      }
    },
    getBtnText () {
      if (this.taskData.justGetThe) {
        return this.$t('FoodC_C_Received_DOQd')
      } else if (this.getCouponStatus === 3) {
        // 待完成
        // 待完成态，“go order”
        return this.$t('FoodC_C_Go_tdhw')
      } else if (
        this.getCouponStatus === 1
      ) {
        // 待领取态，“receive”
        return this.$t('FoodC_C_Collection_rqwP')
      } else if (
        this.getCouponStatus === 2
      ) {
        // 已完成态，“received”
        return this.$t('FoodC_C_Received_DOQd')
      }
    },
    getCouponStatus () {
      if (!this.taskData.isCompleteMission) {
        // 待完成
        return 3
      } else if (
        this.taskData.isCompleteMission &&
        !this.taskData.isReceiveReward
      ) {
        // 待领取
        return 1
      } else if (
        this.taskData.isCompleteMission &&
        this.taskData.isReceiveReward
      ) {
        // 已领取
        return 2
      }
    }
  },
  methods: {
    handleUse () {
      if (!this.taskData.isCompleteMission) {
        // 待完成态，“go order”
        homepageTaskOrderButtonCk({
          button_type: 1,
          task_num: 1,
          ...this.trackEventData()
        }, () => {
          location.href = `${getScheme()}://soda/homePage?closeSideMenu=1`
        })
      } else if (
        this.taskData.isHasReward &&
        this.taskData.isCompleteMission &&
        !this.taskData.isReceiveReward &&
        !this.taskData.justGetThe
      ) {
       
        homepageTaskOrderButtonCk({
          button_type: 3,
          task_num: 1,
          ...this.trackEventData()
        })
        this.$emit('currentTaskClick')
        this.$emit('handleUse', {
          ladderNum: this.taskData.ladderNum,
          index: this.taskData.index
        })
      }
    },
    trackEventData () {
      return {
        activity_type: 1,
        activity_id: this.activityID,
        coupon_id: this.taskData.rewardStrategy[0].couponId,
        batch_id: this.taskData.rewardStrategy[0].batchId,
        coupon_type: 1,
        coupon_status: this.getCouponStatus || '' // 1：可领取 2：已领取，3，未完成任务
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/common/stylus/variables"
.one-task-container
    padding 16px 32px 48px
    display: flex
    align-items: center
.status-icon
    position relative
    width 84px
    height 84px
    img
        width 84px
        height 84px
    .just-get-the
        position relative
        left -21px
        top -21px
        width 126px
        height 126px
.desc-line_content
    margin-left: 12px
    flex 1
.desc-line
    max-width: 318px
    height: 36px;
    font-family: 'Aspira Light';
    font-size: 28px;
    color: #000000;
    line-height: 36px;
    font-weight: 200;
    overflow hidden
    white-space: nowrap;
    text-overflow: ellipsis;
.go-order
    height 60px
    margin-left: 24px
    .rich-btn
      height 60px
      line-height: 60px;
      font-family 'Aspira Medium'
      font-size 28px
      font-weight: 500
      display inline-block
      max-width 200px
      padding 0 24px
      box-sizing border-box
      max-width 200px
      overflow:hidden
      text-overflow ellipsis
      white-space nowrap

  .go-order1{
      button {
        color:#fff;
        background:#999999;
      }
  }
  .go-order1 button:active{
      color:#fff;
      background:#999999;
  }
</style>
